
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexyRtNS6iTOhyckRmeBp_45hI3KJa1Z6_45Wx_srOjMGgcxScMeta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@2/pages/index.vue?macro=true";
import { default as _91slug_93ms5iDxyZcsWXJyM5RfMJ_453_z_45keA_45K4bH_wTfQHChv8Meta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@2/pages/[slug].vue?macro=true";
import { default as indexbU9aIU4gQUR87QRKO_8JxjtZml2IUgX7B5g0aKQWx98Meta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@2/pages/search/index.vue?macro=true";
import { default as productsot2KKn6HTL_TCYGonWvPMu7m8tw1ufWYpPjpbxzCMU8Meta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@2/pages/search/products.vue?macro=true";
import { default as documentsZ3JRFgqkmPxDUpxOL7Re0SQYWlcO6cR0eAFr1MhCjJYMeta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@2/pages/search/documents.vue?macro=true";
import { default as searchEHpD80UJ_45p1AEW3g6tenKDoOWFre1jc9o7JzQ6S5Zr0Meta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@2/pages/search.vue?macro=true";
import { default as _91slug_93t6JjF6lzPgqGyaxEQ4F0vHGnDK6TPrww16OPA4h2L3AMeta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@2/pages/news/[slug].vue?macro=true";
import { default as index55yCbZ8hOfPr_Q_l1fEZ8n6PTSBaALbkRz5rwygUfE4Meta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@2/pages/catalog/index.vue?macro=true";
import { default as _91slug_93hSjiv4vYjFI_Y5bfxlFc_45C9xsy8qTtoEVf3hEkC0pI4Meta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@2/pages/catalog/[slug].vue?macro=true";
import { default as _91slug_93gbxhunFKw9TQx2njx7EYHTiLXcITiQEdPHvLWbRlY7AMeta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@2/pages/product/[slug].vue?macro=true";
import { default as indexkuZMWEZbUScAanmip1MW4KrfxA_4517CL6QczO95drUt8Meta } from "/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@2/pages/documents/[slug]/index.vue?macro=true";
export default [
  {
    name: "index___uk",
    path: "/",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@2/pages/index.vue")
  },
  {
    name: "slug___uk",
    path: "/:slug()",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@2/pages/[slug].vue")
  },
  {
    name: searchEHpD80UJ_45p1AEW3g6tenKDoOWFre1jc9o7JzQ6S5Zr0Meta?.name,
    path: "/search",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@2/pages/search.vue"),
    children: [
  {
    name: "search___uk",
    path: "",
    meta: indexbU9aIU4gQUR87QRKO_8JxjtZml2IUgX7B5g0aKQWx98Meta || {},
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@2/pages/search/index.vue")
  },
  {
    name: "search-products___uk",
    path: "products",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@2/pages/search/products.vue")
  },
  {
    name: "search-documents___uk",
    path: "documents",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@2/pages/search/documents.vue")
  }
]
  },
  {
    name: "news-slug___uk",
    path: "/news/:slug()",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@2/pages/news/[slug].vue")
  },
  {
    name: "catalog___uk",
    path: "/catalog",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@2/pages/catalog/index.vue")
  },
  {
    name: "catalog-slug___uk",
    path: "/catalog/:slug()",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@2/pages/catalog/[slug].vue")
  },
  {
    name: "product-slug___uk",
    path: "/product/:slug()",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@2/pages/product/[slug].vue")
  },
  {
    name: "documents-slug___uk",
    path: "/documents/:slug()",
    component: () => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod@2/pages/documents/[slug]/index.vue")
  }
]